import { gql, useQuery } from "@apollo/client";

export const useActiveLibraryCategories = (parentId: string = undefined) => {
  return useQuery(gql`
    query getActiveLibraryCategories($filter: FilterFindManyLibraryCategoryInput) {
      library_categories_active_only(filter: $filter) {
        _id
        name
        description
        image_id
      }
    }
  `, {
    variables: {
      filter: {
        parent_id: parentId,
      }
    },
    fetchPolicy: "network-only",
  });
};